import React, { SVGProps } from 'react'

const CrossIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 10 10"
    aria-hidden="true"
    {...props}
  >
    <path
      d="M1.476 9.82L5 6.298 8.524 9.82a.61.61 0 00.865 0l.432-.433a.61.61 0 000-.864L6.297 5 9.82 1.476a.62.62 0 000-.864L9.389.179a.61.61 0 00-.865 0L5 3.703 1.476.18a.61.61 0 00-.865 0L.18.612a.61.61 0 000 .864L3.703 5 .18 8.524a.61.61 0 000 .864l.432.433a.61.61 0 00.865 0z"
      fill="currentColor"
    />
  </svg>
)

export default CrossIcon
